export class ArrayHelper {
    static intersect(...arrays) {
        let result = arrays[0];
        if (!result) {
            return [];
        }
        for (let i = 1; i < arrays.length; i += 1) {
            const value = arrays[i];
            if (value) {
                result = this.intersect(result, value);
            }
        }
        return result;
    }
    static contains(array, obj) {
        return array.indexOf(obj) >= 0;
    }
    static any(array, selector) {
        return !!array.find(selector);
    }
    static remove(array, obj) {
        const copy = [...array];
        const index = array.indexOf(obj);
        if (index >= 0) {
            copy.splice(index, 1);
        }
        return copy;
    }
    static removeAll(source, array) {
        const result = source.filter((s) => array.indexOf(s) < 0);
        return result;
    }
    static match(array, regEx, selector) {
        return array.filter((i) => selector(i).match(regEx));
    }
    static replace(array, oldItem, newItem) {
        const copy = [...array];
        const index = copy.indexOf(oldItem);
        if (index >= 0) {
            copy[index] = newItem;
        }
        return copy;
    }
    static unionAll(array, selector) {
        const arrays = array.map((i) => selector(i));
        const result = [];
        for (let i = 0; i < arrays.length; i += 1) {
            const item = arrays[i];
            if (item) {
                result.push(...item);
            }
        }
        return result;
    }
}
//# sourceMappingURL=array-helper.js.map